import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import VideoCreator from './pages/VideoCreator';
import VideoDownload from './pages/VideoDownload';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Creation Flow */}
        <Route path="/" element={<VideoCreator />} />
        
        {/* The URL users click in their email */}
        <Route path="/videos/:jobId" element={<VideoDownload />} />
        
        {/* Admin Dashboard */}
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;